import { getReq } from "./instance";

export const getSideEffectGroup = async (
  sideEffectGroupId: string,
  params = {},
) => {
  return getReq(`/SideEffectGroup/${sideEffectGroupId}`, params);
};
